<template lang="pug">
div
  y-dialog(v-if="showDialog" v-model="showDialog" :max-width="step ? 600 : marketingSetting.plan === 'standalone' ? 600 : 1200" persistent fluid scrollable content-class="round-2xl")
    v-card(height="90vh")
      v-card-title.pa-4
        v-row(no-gutters)
          v-col(cols="10" offset="1")
            .text-xl.font-bold.text-center Enrol new member
          v-col(cols="1" align="right")
            v-btn(icon @click="closeDialog" small color="primary")
              v-icon mdi-close
      v-divider
      v-card-text.pa-6
        v-window(v-model="step" touchless)
          v-window-item(:value="0")
            v-form(ref="form")
              v-row
                v-col.grow(v-if="marketingSetting.plan !== 'standalone'")
                  div
                    div.text-md.font-semibold.neutral700--text Add from existing customer
                    template(v-if="patient")
                      v-card.round-xl.pa-3.mt-3(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
                        div(v-if="editExisting")
                          div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('name') }}
                          v-text-field.text-sm.mt-2.round-xl(v-model="patient.name" placeholder="Enter name" background-color="neutral100" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
                          div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('phone') }}
                          phone-input.mt-2(v-model="patient.phone" required background-color="neutral100" :loading="isFetching" @input="inputChanged($event)")
                          v-card.round-xl.pa-4.mt-3(v-if="registeredPhonePatient" outlined color="neutral100" style="border-color: var(--v-neutral300) !important;")
                            div.d-flex.align-center(v-if="handleRegisteredPhone")
                              v-icon(size="22" color="success500").mr-2 $yzi-check-circle-solid
                              div.text-sm.font-medium.neutral700--text Phone number has been changed to this user
                              v-spacer
                              y-button(label="Undo" outlined size="xs" @click="handleRegisteredPhone = null")
                            template(v-else)
                              div.d-flex.align-center
                                v-icon(size="22" color="danger500").mr-2 $yzi-alert-triangle
                                div.text-sm.font-medium.neutral700--text This phone number has been registered before by:
                              v-card.round-xl.pa-2.mt-3(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
                                div.text-sm.font-medium.neutral700--text {{ registeredPhonePatient.name }}
                                div.text-sm.neutral700--text +{{ registeredPhonePatient.phone }}
                              div.text-sm.neutral700--text.mt-3 You can link the phone number with this user or change it to a new one.
                              v-row.mt-3(dense)
                                v-col
                                  y-button(label="Change number to new user" outlined block size="xs" button-class="px-0" @click="handleRegisteredPhone = 'changed'")
                                v-col
                                  y-button(label="Link phone number with this user" outlined block size="xs" button-class="px-0" @click="linkExistingPatient")
                          
                          div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('email') }} (optional)
                          v-text-field.text-sm.mt-2.round-xl(v-model="patient.email" placeholder="Enter email" background-color="neutral100" outlined dense height="48" hide-details="auto" :rules="patient.email ? rules.valid_email : []")
                        template(v-else)
                          v-row(no-gutters)
                            v-col.grow
                              div.text-md.font-medium.neutral700--text {{ patient.name }}
                              v-row.mt-1(no-gutters)
                                v-col(cols="4")
                                  div.text-sm.font-medium.neutral500--text NRIC
                                v-col.grow
                                  div.text-sm.neutral700--text(v-if="patient.ic") {{ patient.ic }}
                                  div.text-sm.neutral500--text(v-else) No NRIC
                              v-row(no-gutters)
                                v-col(cols="4")
                                  div.text-sm.font-medium.neutral500--text Phone no.
                                v-col.grow
                                  div.text-sm.neutral700--text(v-if="patient.phone") {{ patient.phone }}
                                  div.text-sm.neutral500--text(v-else) No phone
                              v-row(no-gutters)
                                v-col(cols="4")
                                  div.text-sm.font-medium.neutral500--text Email
                                v-col.grow
                                  div.text-sm.neutral700--text(v-if="patient.email") {{ patient.email }}
                                  div.text-sm.neutral500--text(v-else) No email
                            v-col.shrink
                              y-button(label="Edit" outlined size="sm" @click="undoLinkUser")

                          v-card.round-xl.pa-4.mt-3(v-if="handleRegisteredPhone === 'linked'" outlined color="neutral100" style="border-color: var(--v-neutral300) !important;")
                            div.d-flex.align-center
                              v-icon(size="22" color="success500").mr-2 $yzi-check-circle-solid
                              div.text-sm.font-medium.neutral700--text Phone number linked with:
                              v-spacer
                              y-button(label="Undo" outlined size="xs" @click="undoLinkUser")
                            v-card.round-xl.pa-2.mt-3(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
                              div.text-sm.font-medium.neutral700--text {{ registeredPhonePatient.name }}
                              div.text-sm.neutral700--text +{{ registeredPhonePatient.phone }}
                            div.text-sm.neutral700--text.mt-3 You can link the phone number with this user or change it to a new one.
                          
                      div.d-flex.justify-end.mt-3
                        y-button(label="Select different customer" size="sm" @click="clearPatient")
                          
                    div(v-show="!Boolean(patient)")
                      search-patient-dropdown.mt-3(v-model="patient" max-height="345" @change="addExistingPatient")
                    
                v-col.shrink(v-if="marketingSetting.plan !== 'standalone'")
                  div
                    div.vertical
                    div.text-md.font-semibold.neutral700--text.my-3 OR
                    div.vertical

                v-col.grow
                  div
                    div.text-md.font-semibold.neutral700--text Create new customer
                    div
                      div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('name') }}
                      v-text-field.text-sm.mt-2.round-xl(v-model="newPatient.name" placeholder="Enter name" outlined dense height="48" :disabled="Boolean(patient)" :rules="patient ? [] : rules.not_empty" hide-details="auto")
                      div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('phone') }}
                      phone-input.mt-2(v-model="newPatient.phone" :required="!patient" :loading="isFetching" :disabled="Boolean(patient)" @input="inputChanged($event)")
                      template(v-if="!patient")
                        v-card.round-xl.pa-4.mt-3(v-if="registeredPhonePatient" outlined color="neutral100" style="border-color: var(--v-neutral300) !important;")
                          div.d-flex.align-center(v-if="handleRegisteredPhone")
                            v-icon(size="22" color="success500").mr-2 $yzi-check-circle-solid
                            div.text-sm.font-medium.neutral700--text Phone number has been changed to this user
                            v-spacer
                            y-button(label="Undo" outlined size="xs" @click="handleRegisteredPhone = null")
                          template(v-else)
                            div.d-flex.align-center
                              v-icon(size="22" color="danger500").mr-2 $yzi-alert-triangle
                              div.text-sm.font-medium.neutral700--text This phone number has been registered before by:
                            v-card.round-xl.pa-2.mt-3(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
                              div.text-sm.font-medium.neutral700--text {{ registeredPhonePatient.name }}
                              div.text-sm.neutral700--text +{{ registeredPhonePatient.phone }}
                            div.text-sm.neutral700--text.mt-3 You can link the phone number with this user or change it to a new one.
                            div.d-flex.align-center.mt-3
                              y-button(label="Change number to new user" outlined size="xs" @click="openChangeNumberDialog(newPatient.phone)")
                                            
                      div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('email') }} (optional)
                      v-text-field.text-sm.mt-2.round-xl(v-model="newPatient.email" placeholder="Enter email" outlined dense height="48" hide-details="auto" :disabled="Boolean(patient)" :rules="patient ? [] : (newPatient.email ? rules.valid_email : [])")

                      template(v-if="marketingSetting.plan === 'standalone'")
                        div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('date_of_birth') }}
                        v-text-field.text-sm.mt-2.round-xl(v-model="newPatient.dob" placeholder="Enter date of birth" type="date" outlined dense height="48" hide-details="auto" :rules="patient ? [] : rules.not_empty")
          
          v-window-item(:value="1")
            div(v-if="respPatient")
              div(align="center")
                v-icon(size="66" color="success500") $yzi-check-verified-solid-03
                div.text-xl.font-semibold.neutral700--text.text-center.mt-3 You’ve successfully enrolled a new user into your loyalty program!
              v-card.round-xl.pa-4.mt-4(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
                v-row(dense)
                  v-col(cols="4")
                    div.text-sm.neutral700--text Customer:
                  v-col(cols="8")
                    div.text-sm.font-medium.neutral700--text {{ respPatient.name }}
                v-row(dense)
                  v-col(cols="4")
                    div.text-sm.neutral700--text Phone number:
                  v-col(cols="8")
                    div.text-sm.font-medium.neutral700--text +{{ respPatient.phone }}
                v-row(dense)
                  v-col(cols="4")
                    div.text-sm.neutral700--text Loyalty link:
                  v-col(cols="8")
                    div.d-flex.align-center
                      div.text-sm.font-medium.neutral700--text {{ getLoyaltyLink(respPatient) }}
                      v-btn.ml-2(small icon @click="copyLink(respPatient)")
                        v-icon(size="20" color="neutral700") $yzi-copy-03

            div(v-if="linkPatient && patient")
              div(align="center")
                v-icon(size="66" color="success500") $yzi-check-verified-solid-03
                div.text-xl.font-semibold.neutral700--text.text-center.mt-3 You’ve successfully linked a user into existing loyalty members!
              v-card.round-xl.pa-4.mt-4(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
                v-row(dense)
                  v-col(cols="4")
                    div.text-sm.neutral700--text Customer:
                  v-col(cols="8")
                    div.text-sm.font-medium.neutral700--text {{ patient.name }}
                v-row(dense)
                  v-col(cols="4")
                    div.text-sm.neutral700--text Linked to:
                  v-col(cols="8")
                    div.text-sm.font-medium.neutral700--text {{ linkPatient.name }}
                v-row(dense)
                  v-col(cols="4")
                    div.text-sm.neutral700--text Phone number:
                  v-col(cols="8")
                    div.text-sm.font-medium.neutral700--text +{{ linkPatient.phone }}
                v-row(dense)
                  v-col(cols="4")
                    div.text-sm.neutral700--text Loyalty link:
                  v-col(cols="8")
                    div.d-flex.align-center
                      div.text-sm.font-medium.neutral700--text {{ getLoyaltyLink(respPatient) }}
                      v-btn.ml-2(small icon @click="copyLink(respPatient)")
                        v-icon(size="20" color="neutral700") $yzi-copy-03
                      

            v-alert.mt-4.round-xl(color="warning500" text)
              div.d-flex.align-center
                v-icon.mr-4(color="yellow600" size="22") $yzi-mail-01
                div.text-sm.font-medium.neutral700--text Loyalty program link will be sent along with welcoming message to your customer via
                  span.ml-1.font-bold message, WhatsApp, and email.

            div(ref="copy")

      v-divider
      v-card-actions.py-4.px-6
        template(v-if="step")
          v-spacer
          y-button.mr-3(:label="`Collect ${loyaltySystem}`" size="md" dark outlined @click="collectValue")
          y-button(label="Done" size="md" dark @click="doneEnrol")
        template(v-else)
          y-button(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="closeDialog")
          v-spacer
          y-button(label="Enrol" size="md" dark :loading="isLoading" :disabled="disableEnrol" @click="saveData")

  .dialogs
    change-member-number-dialog(v-if="showChangeNumberDialog" :open.sync="showChangeNumberDialog" :phone-number="selectedPhone" @updated="updatePhoneNumber" @closed="closed")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import SearchPatientDropdown from '@/components/clinic/registration/SearchPatientDropdown.vue'
import PhoneInput from '@/components/clinic/custom/PhoneInput.vue'
import ChangeMemberNumberDialog from '@/components/clinic/marketing/dialogs/ChangeMemberNumberDialog.vue'

export default {
  components: { SearchPatientDropdown, ChangeMemberNumberDialog, PhoneInput },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    loyaltySystem: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      isLoading: false,
      isFetching: false,
      showChangeNumberDialog: false,
      editExisting: false,
      oriPatient: null,
      patient: null,
      registeredPhonePatient: null,
      handleRegisteredPhone: null,
      selectedPhone: null,
      respPatient: null,
      linkPatient: null,
      step: 0,
      newPatient: {},
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required'],
        valid_email: [ v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid', ]
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      marketingSetting: 'marketing/getMarketingSettings'
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    disableEnrol () {
      let disable = false
      if (this.registeredPhonePatient && !this.handleRegisteredPhone) {
        disable = true
      }
      return disable
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions(['showMessage']),
    inputChanged: debounce(function (phone) {
      if (this.oriPatient && this.oriPatient.phone !== phone) {
        this.checkPhone(phone)
      }
      if (this.newPatient.phone) {
        this.checkPhone(phone)
      }
    }, 750),
    checkPhone (phone) {
      this.isFetching = true
      this.registeredPhonePatient = null
      let params = {
        dormant: false,
        phone: phone,
        expand: 'customers'
      }
      this.$axios.get(`/loyalty/${this.company.slug}/members`, { params })
        .then(resp => {
          if (resp.data.results.length) {
            this.registeredPhonePatient = resp.data.results[0]
            this.editExisting = true
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      this.isLoading = true
      if (this.registeredPhonePatient && this.handleRegisteredPhone === 'linked') {
        this.linkCustomer(this.registeredPhonePatient.id)
        return
      }
      let payload = {
        name: this.newPatient.name || this.patient.name,
        phone: this.newPatient.phone || this.patient.phone,
        email: this.newPatient.email || this.patient?.email || null,
      }
      if (this.marketingSetting.plan === 'standalone') {
        payload.dob = this.newPatient.dob
      }
      if (this.patient) {
        payload.customer = this.patient.id
      }
      if (this.registeredPhonePatient && this.handleRegisteredPhone === 'changed') {
        payload.dormant_member = this.registeredPhonePatient.id
      }
      this.$axios.post(`/loyalty/${this.company.slug}/members`, payload)
        .then(resp => {
          this.respPatient = resp.data
          this.step = 1
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    linkCustomer (id) {
      this.$axios.post(`/loyalty/${this.company.slug}/members/${id}/link_customer`, { customer: this.patient.id })
        .then(resp => {
          this.linkPatient = resp.data
          this.step = 1
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    addExistingPatient () {
      if (!this.patient) {
        return
      }
      this.oriPatient = JSON.parse(JSON.stringify(this.patient))
      if (this.patient.phone) {
        this.checkPhone(this.patient.phone)
      } else {
        this.editExisting = true
      }
      this.editExisting = false
      this.newPatient = {}
    },
    linkExistingPatient () {
      this.patient = JSON.parse(JSON.stringify(this.oriPatient))
      this.handleRegisteredPhone = 'linked'
      this.editExisting = false
    },
    undoLinkUser () {
      this.handleRegisteredPhone = null
      this.editExisting = true
    },
    openChangeNumberDialog (phone) {
      this.showChangeNumberDialog = true
      this.selectedPhone = phone
    },
    updatePhoneNumber () {
      this.handleRegisteredPhone = 'changed'
    },
    getLoyaltyLink (patient) {
      return `https://${this.company.slug}.yezza.co/loyalty/${patient.pid}`
    },
    copyLink (member) {
      let url = this.getLoyaltyLink(member)
      let container = this.$refs.copy
      this.$copyText(url, container)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
        })
    },
    doneEnrol () {
      this.$emit('updated')
      this.closeDialog()
    },
    collectValue () {
      this.$emit('collect', this.respPatient)
      this.closeDialog()
    },
    closed () {
      this.showChangeNumberDialog = false
      this.selectedPhone = null
    },
    clearPatient () {
      this.editExisting = false
      this.oriPatient = null
      this.patient = null
      this.registeredPhonePatient = null
      this.handleRegisteredPhone = null
      this.selectedPhone = null
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
.vertical {
  height: 28vh;
  border-right: solid 1px var(--v-basic400);
  margin-right: 10px;
}
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>